<template>
<div>
  <hb-modal v-model="dialog" size="medium" title="Warning!" show-help-link confirmation>
    <template v-slot:content>
        <div class="px-6 py-4">
          You should only include Gate Code by Text in your auto-attendant menu if you are comfortable with tenants, who have not been ID verified, accessing their gate code using this feature. Today, the system will send gate code by text to any tenant, who requests it, regardless of whether they were ID verified on move-in. For assistance or more information, contact Tenant Inc Customer Support.
        </div>
    </template> 
    <template v-slot:actions>
        <hb-btn color="primary"  @click="$emit('confirm-charm', true)">I Understand</hb-btn>
    </template>
  </hb-modal>
</div>
</template>

<script type="text/babel">
  export default {
    name: "CharmEnableConfirmation",
    data() {
      return {};
    },
    props: {
      value:{
        type: Boolean,
        default: false
      },
    },
    computed: {
      dialog: {
          get () {
            return this.value
          },
          set (value) {
            this.$emit('input', value)
            if (!value) {
                this.$emit('close');
            }
          }
      },
    }
  }

</script>

<style type="scss" scoped></style>